module.exports = __webpack_public_path__ + "img/Bilde3.c7bc2e4b.jpg";